import {
    useState
} from "react";
import {
    View
} from "react-native";
import type {
    NotificationTabType
} from "./type";
import stylesheet from "./stylesheet";
import MailsList from "./views/mailsList";
import NotificationsList from "./views/notificationsList";
import SendMailModal from "./views/sendMailModal";
import SendNotificationModal from "./views/sendNotificationModal";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    PageContainer,
    Button,
    Text
} from "ncore-ui-kit";
import {
    BellIcon,
    MailIcon
} from "lucide-react-native";

const NotificationsPage = () => {
    const {
        radiuses,
        spaces,
        colors
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const [
        activeTab,
        setActiveTab
    ] = useState<NotificationTabType>("notifications");

    const [
        isSendNotificationModalVisible,
        setIsSendNotificationModalVisible
    ] = useState<boolean>(false);

    const [
        isSendMailModalVisible,
        setIsSendMailModalVisible
    ] = useState<boolean>(false);

    const [
        refreshKey,
        setRefreshKey
    ] = useState<number>(0);

    const handleRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const renderHeader = () => {
        return <View
            style={[
                stylesheet.headerContainer,
                {
                    marginBottom: spaces.spacingXl,
                    gap: spaces.spacingLg
                }
            ]}
        >
            <View
                style={[
                    stylesheet.titleContainer,
                    {
                        gap: spaces.spacingXs
                    }
                ]}
            >
                <Text
                    customColor={colors.content.text.high}
                    variant="titleLargeSize"
                >
                    {localize("notifications-page-title")}
                </Text>
                <Text
                    customColor={colors.content.text.mid}
                    variant="bodyMediumSize"
                >
                    {localize("notifications-page-description")}
                </Text>
            </View>
            <View
                style={[
                    stylesheet.tabsContainer,
                    {
                        backgroundColor: colors.content.container.subtle,
                        borderRadius: radiuses.md,
                        padding: spaces.spacingXs,
                        gap: spaces.spacingSm
                    }
                ]}
            >
                <Button
                    customBorderColor={activeTab === "notifications" ? undefined : "secondaryButton"}
                    customColor={activeTab === "notifications" ? undefined : "secondaryButton"}
                    variant={activeTab === "notifications" ? "filled" : "outline"}
                    type={activeTab === "notifications" ? "primary" : "neutral"}
                    title={localize("notifications-tab-notifications")}
                    onPress={() => setActiveTab("notifications")}
                    customTextColor={colors.project.brandWhite}
                    icon={({
                        size
                    }) => <BellIcon
                        color={colors.project.brandWhite}
                        size={size}
                    />}
                    spreadBehaviour="free"
                />
                <Button
                    customBorderColor={activeTab === "mails" ? undefined : "secondaryButton"}
                    customColor={activeTab === "mails" ? undefined : "secondaryButton"}
                    variant={activeTab === "mails" ? "filled" : "outline"}
                    type={activeTab === "mails" ? "primary" : "neutral"}
                    customTextColor={colors.project.brandWhite}
                    title={localize("notifications-tab-mails")}
                    onPress={() => setActiveTab("mails")}
                    icon={({
                        size
                    }) => <MailIcon
                        color={colors.project.brandWhite}
                        size={size}
                    />}
                    spreadBehaviour="free"
                />
            </View>
        </View>;
    };

    const renderContent = () => {
        if(activeTab === "notifications") {
            return <NotificationsList
                onOpenSendModal={() => setIsSendNotificationModalVisible(true)}
                key={`notifications-${refreshKey}`}
            />;
        }

        return <MailsList
            onOpenSendModal={() => setIsSendMailModalVisible(true)}
            key={`mails-${refreshKey}`}
        />;
    };

    return <PageContainer
        style={stylesheet.container}
    >
        {renderHeader()}
        <View
            style={[
                stylesheet.contentContainer,
                {
                    marginTop: spaces.spacingSm
                }
            ]}
        >
            {renderContent()}
        </View>
        <SendNotificationModal
            onClose={() => setIsSendNotificationModalVisible(false)}
            isVisible={isSendNotificationModalVisible}
            onSuccess={handleRefresh}
        />
        <SendMailModal
            onClose={() => setIsSendMailModalVisible(false)}
            isVisible={isSendMailModalVisible}
            onSuccess={handleRefresh}
        />
    </PageContainer>;
};
export default NotificationsPage;
